export default __webpack_public_path__ + "static/media/045-keyboard.f49c2fa6.svg";